import React from 'react';
import BordereauStateFactory from '../../../classes/bordereaux/state/BordereauStateFactory';
import type BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import TreeViewType from '../../../constants/liquidation/TreeViewType';
import useLiquidationTreeviewStore from '../../../stores/liquidationTreeviewStore';
import LiquidationTreeview from './LiquidationTreeview';
import FiltersTreeview from './Mouvement/FiltersTreeview';
import './LiquidationContainer.css';
import { useWindowDimensions } from '@mairistem/finances-utils';

const isSameStates = (
	a: Set<BordereauStateType> | null,
	b: Set<BordereauStateType>,
): boolean => a?.size === b.size && [...b].every((state) => a.has(state));

const LiquidationContainer = () => {
	// filtres conservés dans le store : retrouvés au retour d'une fiche
	const selectedAnnee = useLiquidationTreeviewStore(
		(state) => state.anneeExercice,
	);
	const selectedSens = useLiquidationTreeviewStore((state) => state.sens);
	const selectedBordereauState = useLiquidationTreeviewStore(
		(state) => state.etatBordereau,
	);
	const { setAnneeExercice, setSens, setEtatBordereau } =
		useLiquidationTreeviewStore.getState();

	// null tant que l'arbre ne les a pas calculés : le filtre d'état restauré ne doit pas être effacé avant
	const [visibleStates, setVisibleStates] =
		React.useState<Set<BordereauStateType> | null>(null);

	const { height } = useWindowDimensions();

	const handleVisibleStatesChange = React.useCallback(
		(states: Set<BordereauStateType>): void => {
			setVisibleStates((previous) =>
				isSameStates(previous, states) ? previous : states,
			);
		},
		[],
	);

	React.useEffect(() => {
		if (selectedBordereauState === null || visibleStates === null) return;

		const selectedState = BordereauStateFactory.getAllStates().find(
			(state) => state.step === selectedBordereauState,
		);

		if (!selectedState || !visibleStates.has(selectedState.state)) {
			setEtatBordereau(null);
		}
	}, [visibleStates, selectedBordereauState, setEtatBordereau]);

	return (
		<div className="liquidation-container">
			<FiltersTreeview
				onAnneeChange={setAnneeExercice}
				onSensChange={setSens}
				selectedAnnee={selectedAnnee}
				selectedSens={selectedSens}
				selectedBordereauState={selectedBordereauState}
				onFiltreBordereauChange={setEtatBordereau}
				visibleStates={visibleStates}
			/>
			{selectedAnnee && (
				<LiquidationTreeview
					key={selectedAnnee}
					type={TreeViewType.MOUVEMENT}
					height={height}
					anneeExercice={selectedAnnee}
					filterSens={selectedSens}
					filtreBordereauState={selectedBordereauState}
					onVisibleStatesChange={handleVisibleStatesChange}
				/>
			)}
		</div>
	);
};

export default LiquidationContainer;
